<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '38rem' }"
  styleClass="bulk-pricing-dialog"
>
  <div class="bp-header">
    <h2 class="bp-title">Bulk Pricing</h2>
  </div>

  <p class="bp-subtitle">
    Save more when ordering larger quantities. Pricing may vary by selected size.
  </p>

  <div class="bp-divider"></div>

  @if (sizes().length > 1) {
    <div class="bp-size-row">
      <span class="bp-size-label">Choose a size</span>
      <span class="bp-selected">
        Selected:
        <b>{{ activeSize() }}</b>
      </span>
    </div>

    <div class="bp-size-pills">
      @for (s of sizes(); track s.id) {
        <button
          type="button"
          class="bp-pill"
          [class.bp-pill-active]="activeSize() === s.size"
          (click)="selectSize(s.size)"
        >
          {{ s.size }}
        </button>
      }
    </div>
  }

  @if (rows().length) {
    <table class="bp-table">
      <thead>
        <tr>
          <th>Quantity</th>
          <th class="bp-col-center">Unit Price</th>
          <th class="bp-col-right">Savings</th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows(); track row.id) {
          <tr [class.bp-row-best]="row.isBestValue">
            <td>{{ row.label }} items</td>
            <td class="bp-col-center bp-price">{{ row.price | price | usdPipe }} each</td>
            <td class="bp-col-right">
              @if (row.isBestValue) {
                <span class="bp-badge bp-badge-best">Best value</span>
              } @else if (row.savingsPercent) {
                <span class="bp-badge">Save {{ row.savingsPercent }}%</span>
              } @else {
                <span class="bp-dash">—</span>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>

    <div class="bp-note">
      The applicable unit price will be calculated automatically based on the selected size and
      total quantity.
    </div>
  } @else {
    <p class="bp-note">No bulk pricing available for this size.</p>
  }

  <div class="bp-divider"></div>

  <div class="bp-footer">
    <button type="button" class="bp-close-btn" (click)="close()">Close</button>
  </div>
</p-dialog>
